module.exports = __webpack_public_path__ + "static/img/product1-1.e389b47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product1-1.jpg
// module id = RlY1
// module chunks = 0